import React from 'react';
import { Text, Crate } from '@perch-labs/shrike';
import { copyFor } from 'config';
import {
  EnrollmentTimeline,
  EnrollmentStatus,
} from 'components/enrollment-timeline';

const getCopy = copyFor('billing.statement.communitySolarUpdate');

interface Props {
  projectName?: string;
  projectStartDate?: string;
  stateAbbreviation?: string;
  vnmSubscriptionStatus: VnmEnrollmentStatus | null;
}
export const CommunitySolarUpdate = ({
  projectName,
  projectStartDate,
  stateAbbreviation,
  vnmSubscriptionStatus,
}: Props) => {
  return (
    <Crate>
      <Text
        textStyle="heading700"
        tag="h2"
        margin={{ top: '24px', bottom: '24px' }}
      >
        {getCopy('title')}
      </Text>
      <Text margin={{ bottom: '8px' }}>{getCopy('subtitle')}</Text>
      <EnrollmentTimeline
        backgroundColor="primary"
        project={projectName}
        stateAbbreviation={stateAbbreviation || ''}
        status={
          vnmSubscriptionStatus === 'waitlist'
            ? EnrollmentStatus.Waitlist
            : EnrollmentStatus.Pending
        }
        projectStartDate={projectStartDate}
      />
    </Crate>
  );
};
